import './PackagingComponent.scss';
import { ProductVM } from '../../../../common/view-model';
import { packagingState } from './model';
import { FC, useState } from 'react';
interface IPackagingComponentProps {
	product: ProductVM | undefined;
}
export const PackagingComponent: FC<IPackagingComponentProps> = ({ product }) => {
	const [state] = useState({ ...packagingState });
	return (
		<div data-testid='packaging-component' className='packaging-container'>
			<span className='packaging'>
				<span className='packaging-title'> {state.shelfLifeText} </span>
				<span className='packaging-info'>
					{product?.shelfLife ? `${Math.trunc(product?.shelfLife)} days` : state.notAvailableText}
				</span>
			</span>
			<span className='packaging'>
				<span className='packaging-title'>{state.netContentText} </span>
				<span className='packaging-info'>{product?.netContent}</span>
			</span>
			<span className='packaging'>
				<span className='packaging-title'>{state.itemTypeText}</span>
				<span className='packaging-info'> Unit.</span>
			</span>
			{product?.dimensions &&
			product?.dimensions?.height &&
			product?.dimensions?.width &&
			product?.dimensions?.depth &&
			product?.dimensions?.weight ? (
				<span className='packaging'>
					<span className='packaging-title'>{state.dimensionsText}</span>
					<div className='packaging-table-container'>
						<table>
							<tbody>
								{product?.dimensions?.height && (
									<tr>
										<td>Height</td>
										<td>{product?.dimensions?.height}</td>
									</tr>
								)}
								{product?.dimensions?.width && (
									<tr>
										<td>Width</td>
										<td>{product?.dimensions?.width}</td>
									</tr>
								)}
								{product?.dimensions?.depth && (
									<tr>
										<td>Depth</td>
										<td>{product?.dimensions?.depth}</td>
									</tr>
								)}

								{product?.dimensions?.weight && (
									<tr>
										<td>Weight</td>
										<td>{product?.dimensions?.weight}</td>
									</tr>
								)}
							</tbody>
						</table>
					</div>
				</span>
			) : (
				<span className='packaging'>
					<span data-testid='no-dimensions' className='packaging-title'>
						{state.dimensionsText} <span className='packaging-info'>{state.noDimensionsText}</span>
					</span>
				</span>
			)}
		</div>
	);
};
